/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Card } from '../../../Shared/Card'
import { LoadingPlaceholderCardContent } from '../../../Shared/LoadingPlaceholderCardContent'

const cardStyles = css`
    .card-content {
        width: 265px;
        height: 110px;
`

const IntegrationStateCardLoadingPlaceholder = () => {
    return (
      <>
          <Card css={cardStyles}>
              <LoadingPlaceholderCardContent/>
          </Card>
          <Card css={cardStyles}>
              <LoadingPlaceholderCardContent/>
          </Card>
      </>
    )
}

export { IntegrationStateCardLoadingPlaceholder }
